<template>
  <div>
    <el-dialog title="导入会话" :visible.sync="visible" :close-on-click-modal="false" top="6vh"  @close="$emit('close')">
      <div class="ctn">
        <div class="import-path">
          <div class="import-path-title">导入路径:</div>
          <el-input v-model="importPath" size="mini" />
        </div>

        <!-- <div class="conflict">
          <div class="conflict-title">如果会话已存在:</div>
          <div>
            <el-radio v-model="conflictAction" label="override">覆盖</el-radio>
            <el-radio v-model="conflictAction" label="ignore">忽略</el-radio>
            <el-radio v-model="conflictAction" label="rename">重命名</el-radio>
          </div>
        </div> -->

        <div class="drag-area">
          <el-upload action="" class="uplaoder" 
          :show-file-list="true" :multiple="false" :limit="1" :file-list="fileList"
          :http-request="importHandler" :auto-upload="false" :on-change="changeHandler" drag>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将导出的会话文件拖到此处，或<em>选择文件</em></div>
          </el-upload>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="hide" size="mini">关 闭</el-button>
        <el-button type="primary" @click="importHandler" size="mini">导 入</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import path from 'path'

export default {
  name: "importSession",
  data() {
    return {
      visible: false,
      conflictAction: "rename",
      defaultPath: "/imported",
      importPath: "/imported",
      fileList: [],
      name: "",
      text: "",
    }
  },
  methods: {
    show() {
      this.visible = true
    },
    hide() {
      this.visible = false
    },
    importHandler() {
      console.log("import sess to server")
      let self = this
      let path = `${this.env.sess.basePath}/${self.importPath}` // String | 需要还原的目录路径, 该目录必须不存在, 由接口调用在构建目录和文件时自动创建, 上层目录如果不存在则会自动创建
      let data = undefined // Dir | 来自 [GET] /dir/recursive/data 的数据, 用以在服务端反向构建目录和文件
      try {
        data = JSON.parse(self.text)
      } catch (error) {
        this.$message.error("无效的会话文件")
        this.fileList = []
        return
      }
      this.api.hifs.postDirRecursiveData(path, data, (error, data, response) => {
        if (error) {
          self.api.errHandler(self, error, response)
          return
        }
        this.$message.success("导入成功")
        this.$emit("success")
      })
    },
    // 文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用
    // args: (file, fileList)
    changeHandler: function(file) {
      let self = this
      self.name = file.name
      self.importPath = `${self.defaultPath}/${path.basename(file.name, ".watsess")}`

      let reader = new FileReader()
      reader.readAsText(file.raw)
      reader.onload = () => {
        self.text = reader.result
      }
    },
  },
}
</script>

<style scoped>
.import-path {
  display: flex;
  align-items: baseline;
}
.import-path-title {
  width: 5em;
  margin-right: 1em;
  word-break: keep-all;
}
/* .conflict {
  margin-top: 1em;
  display: flex;
  align-items: baseline;
}
.conflict-title {
  margin-right: 1em;
} */
.drag-area {
  margin-top: 2em;
}

/deep/
.el-upload {
  width: 100%;
}

/deep/
.el-upload-dragger {
  width: 100%;
  height: 180px;
}

/deep/
.el-upload-list__item-name {
  text-align: left;
}
</style>